module.exports = "/static/assets/298e234a90ef1161c01bdeeb833fa142.png";